export const TOUR_ASSETS_CACHE = 'tour-assets-v1';
export const APP_ASSETS_CACHE = 'app-assets-v1';
